import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import TemplateRegistry from './components/TemplateRegistry';
import NotFound from './components/NotFound';
import HomePage from './components/HomePage';
import Login from './components/Login';
import OfflineDetector from './components/OfflineDetector';
import { isValidClientId, getClientConfig } from './config/clientConfig';
import './App.css';

// Component to validate client ID and load correct template
function ValidatedForm() {
  const { clientId } = useParams();

  if (isValidClientId(clientId)) {
    const clientConfig = getClientConfig(clientId);
    const templateType = clientConfig.templateType || 'template7';

    return <TemplateRegistry templateType={templateType} clientId={clientId} />;
  } else {
    return <Navigate to="/not-found" replace />;
  }
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <OfflineDetector />
          <Routes>
            {/* Home page - Template showcase */}
            <Route path="/" element={<HomePage />} />

            {/* Admin Login page */}
            <Route path="/login" element={<Login />} />

            {/* Route with client ID parameter */}
            <Route path="/form/:clientId" element={<ValidatedForm />} />

            {/* 404 Not Found page */}
            <Route path="/not-found" element={<NotFound />} />

            {/* Catch all - redirects to not found */}
            <Route path="*" element={<Navigate to="/not-found" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
